import { ForgotPassword } from 'features/auth/components/forgot-password';
import { ResetPassword } from 'features/auth/components/forgot-password/reset-password';
import { Login } from 'features/auth/components/login';
import { PasswordChange } from 'features/auth/components/password-change';
import { TwoFactor } from 'features/auth/components/two-factor';
import { useEffect } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { toAbsoluteUrl } from 'utils/assets';

const AuthLayout = () => {
  useEffect(() => {
    document.body.style.backgroundImage = 'none';
    return () => {
      // empty
    };
  }, []);

  return (
    <div
      className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`
      }}
    >
      {/* begin::Content */}
      <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
        {/* begin::Logo */}
        <a href="#" className="mb-12">
          <img alt="Logo" src={toAbsoluteUrl('/media/logos/default-dark.svg')} className="theme-dark-show h-45px" />
          <img alt="Logo" src={toAbsoluteUrl('/media/logos/default.svg')} className="theme-light-show h-45px"></img>
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className="w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className="d-flex flex-center flex-column-auto p-10">
        <div className="d-flex align-items-center fw-semibold fs-6">
          <a href="#" className="text-muted text-hover-primary px-2">
            About
          </a>

          <a href="#" className="text-muted text-hover-primary px-2">
            Contact
          </a>

          <a href="#" className="text-muted text-hover-primary px-2">
            Contact Us
          </a>
        </div>
      </div>
      {/* end::Footer */}
      <ToastContainer autoClose={2000} theme="light" />
    </div>
  );
};

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path="login" element={<Login />} />
      <Route path="two-factor" element={<TwoFactor />} />
      <Route path="change-password" element={<PasswordChange />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="reset-password" element={<ResetPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
);

export { AuthPage };
